import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "../../data";
import { useDispatch, useSelector } from "react-redux";
import { alertActions } from "../../redux/action";

const ProtectedPages = () => {
  const dispatch = useDispatch();
  const user = useSelector((el) => el.authentication.user);
  let tokenData = user?.jwt_token?.split(".")[1];
  let token;
  if (tokenData) {
    token = JSON.parse(atob(tokenData));
  }

  const isAuth = !!token?.seller_verified;

  // Check seller application status - allow access to dashboard (shows status)
  // but block other seller pages if application is pending/rejected
  const sellerAppStatus = user?.seller_application_status || user?.data?.seller_application_status;
  const isPendingOrRejected = sellerAppStatus === "pending" || sellerAppStatus === "rejected" || sellerAppStatus === "reapply_eligible";

  if (isAuth !== true) {
    dispatch(alertActions.error("You have no seller account"));
  }

  // If authenticated but application not approved, redirect to dashboard (which shows status)
  if (isAuth && isPendingOrRejected) {
    return <Outlet />;
  }

  return isAuth ? <Outlet /> : <Navigate to={ROUTES.SELLER_REGISTRATION} />;
};

export default ProtectedPages;
